import React from "react";
import LandmarkLogo from "../LandmarkLogo";
import { Headshot } from "./shared";

// White canvas, inset hairline border, centered rounded-square headshot.
export default function MinimalCard({ data, headshot }) {
  const name = data.name || "New Hire";
  return (
    <div className="wp-canvas wp-t-minimal">
      <div className="wp-t-minimal__frame" />

      <header className="wp-t-minimal__top">
        <LandmarkLogo width={220} />
      </header>

      <Headshot headshot={headshot} className="wp-t-minimal__photo" />

      <div className="wp-t-minimal__copy">
        <p className="wp-t-minimal__eyebrow">Please welcome</p>
        <h1>{name}</h1>
        {data.role && <p className="wp-t-minimal__role">{data.role}</p>}
        <span className="wp-t-minimal__rule" />
        <p className="wp-t-minimal__meta">
          {data.team && <span>{data.team}</span>}
          {data.team && data.tagline && <i />}
          {data.tagline && <span>{data.tagline}</span>}
        </p>
      </div>

      <footer className="wp-t-minimal__footer">
        <span>landmarkventures.com</span>
        {data.note && <span className="wp-t-minimal__note">{data.note}</span>}
      </footer>
    </div>
  );
}
